import { Staff } from '../types';

import apiClient from '@/axios/app-client';

// API endpoint constant
const STAFFS_ENDPOINT = '/v1/staffs';

export const staffsService = {
  getStaffs: async (params: Record<string, unknown> = {}) => {
    const response = await apiClient.get<Staff[]>(STAFFS_ENDPOINT, params);
    return response.data.data;
  },
};
